import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";
import { VIZ } from "../../css/brandTokens";

// Barras horizontales de serie única (spec 010, plan.md §3.3-bis). Molde ESTRUCTURAL de
// `components/pharos/components/BarChartCard.jsx` — no su paleta arcoíris (RF-30). Un solo
// `<Bar fill={VIZ.serie}>`, SIN `<Cell>`: nada de un color por barra sobre una categoría sin orden
// natural. La consumen Clubhouse, Tipo de IA, Estrategia, Vigilancia, Checklist y Champions.
//
// `valorKey` decide el LARGO de la barra (siempre numérico); `labelKey` (opcional, por defecto = valorKey)
// decide el TEXTO que se ve al final de la barra — permite, p. ej., que Champions muestre
// "4 · 9.5 —" (Habilitadas + días promedio) sin escribir un componente nuevo para ese bloque.
const BarrasCategoria = ({
  datos,
  height = 220,
  nombreKey = "Nombre",
  valorKey = "Total",
  labelKey,
  anchoEtiquetas = 150,
}) => {
  const etiquetaKey = labelKey || valorKey;
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={datos} layout="vertical" margin={{ top: 4, right: 48, left: 4, bottom: 4 }}>
        <CartesianGrid stroke={VIZ.grid} horizontal={false} />
        <XAxis type="number" hide />
        <YAxis
          type="category"
          dataKey={nombreKey}
          width={anchoEtiquetas}
          stroke={VIZ.axis}
          tickLine={false}
          tick={{ fill: VIZ.ink2, fontSize: 12 }}
        />
        <Tooltip
          cursor={{ fill: "rgba(17,17,19,.05)" }}
          contentStyle={{ borderRadius: 8, borderColor: VIZ.grid, fontSize: 13 }}
        />
        <Bar dataKey={valorKey} fill={VIZ.serie} radius={[0, 4, 4, 0]} maxBarSize={20}>
          <LabelList dataKey={etiquetaKey} position="right" style={{ fill: VIZ.ink, fontSize: 12, fontWeight: 600 }} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarrasCategoria;
